export enum AccountActionsTypes {
  FETCH_ACCOUNT = 'FETCH_ACCOUNT',
  CLEAR = 'CLEAR'
}